"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../../Theme"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _Text = _interopRequireDefault(require("../../Text"));

var _mobileDropdownHeader = _interopRequireDefault(require("./mobileDropdownHeader.proptypes"));

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var HeaderContainer = _styledComponents.default.div.withConfig({
  displayName: "MobileDropdownHeader__HeaderContainer",
  componentId: "tu87uy-0"
})(["display:flex;position:relative;width:100vw;align-items:center;box-sizing:border-box;height:50px;padding:", ";box-shadow:0px 4px 4px rgba(0,0,0,0.08);background-color:", ";outline:none;"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.medium;
}, function (_ref2) {
  var theme = _ref2.theme,
      backgroundColor = _ref2.backgroundColor;
  return "".concat(theme.backgroundColor[backgroundColor]);
});

var IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "MobileDropdownHeader__IconWrapper",
  componentId: "tu87uy-1"
})([""]);

var MobileDropDownHeader = function MobileDropDownHeader(props) {
  var label = props.label,
      theme = props.theme,
      backgroundColor = props.backgroundColor,
      labelColor = props.labelColor,
      bold = props.bold,
      onIconClick = props.onIconClick,
      iconColor = props.iconColor,
      customProperties = props.customProperties,
      idConfig = props.idConfig;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var _ref3 = idConfig || {},
      parentName = _ref3.parentName,
      widgetName = _ref3.widgetName,
      index = _ref3.index;

  var _useState = (0, _react.useState)('mobileDropdown'),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      dynamicID = _useState2[0],
      setId = _useState2[1];

  (0, _react.useEffect)(function () {
    var url = 'mobileDropdown';

    if (parentName) {
      url = "".concat(parentName, "-mobileDropdown");
    }

    if (index) {
      url += "-".concat(index);
    }

    if (widgetName) {
      url = "".concat(widgetName, "-").concat(url);
    }

    setId(url);
  }, [widgetName, parentName, index]);

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(HeaderContainer, (0, _extends2.default)({
      backgroundColor: backgroundColor
    }, customProperties), /*#__PURE__*/_react.default.createElement(IconWrapper, {
      onClick: function onClick() {
        return onIconClick();
      },
      id: dynamicID
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: _constant.ICON.TYPE,
      color: iconColor,
      fontsize: _constant.ICON.SIZE,
      theme: theme
    })), /*#__PURE__*/_react.default.createElement(_Text.default, {
      theme: theme,
      color: labelColor,
      bold: bold
    }, label));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

MobileDropDownHeader.propTypes = _mobileDropdownHeader.default.PropTypes;
MobileDropDownHeader.defaultProps = _mobileDropdownHeader.default.DefaultProps;
var _default = MobileDropDownHeader;
exports.default = _default;